export default "__VITE_ASSET__cea85337__"